import { Search as CXSearch, SIZE as CXSearchSize } from '@sanlamcx/react-ui-next-search';

type Search = typeof CXSearch;

export const Search: Search = CXSearch;
export const SearchSize = CXSearchSize;
